import { render, staticRenderFns } from "./PcIdxNum12M.vue?vue&type=template&id=57f4d63a&"
import script from "./PcIdxNum12M.vue?vue&type=script&lang=js&"
export * from "./PcIdxNum12M.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports